/* eslint-disable react/jsx-curly-newline */
/* eslint-disable no-unused-expressions */
import { useEffect, useContext } from 'react'
import { useSelector, shallowEqual } from 'react-redux'
import classNames from 'classnames'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
import { createUseStyles, useTheme } from 'react-jss'
import LoaderEngine from '@/components/LoaderEngine'
import ConditionalWrapper from '@/components/ConditionalWrapper'
import Header from '@/components/Header'
import Overlay from '@/components/Overlay'
import Nav from '@/components/Nav'
import Spinner from '@/components/Spinner'
import CollectionNav from '@/components/CollectionNav'
import Modal from '@/components/Modal'
import NewsletterPopup from '@/components/NewsletterPopup'
import SVGSprite from '@/components/SVGSprite'
import { Context as LoadingContext } from '@/context/loading'
import constants from '@/constants'
import global from '@/global'
import devMode from '@/utils/devmode'
import ShopToastNotification from './components/ShopToastNotification'

const useStyles = createUseStyles(global)

const Layout = ({ children }) => {
  const classes = useStyles()
  const { ready } = useContext(LoadingContext)
  const theme = useTheme()

  const { mainNav, extraNav, languageNav, collectionNav, mediaQueryKey, strings } = useSelector((state) => ({
    mainNav: state.nav.mainMenu,
    extraNav: state.nav.extraMenu,
    collectionNav: state.nav.collectionMenu,
    languageNav: state.nav.languageMenu,
    pathname: state.router.location.pathname,
    strings: state.language.string,
    mediaQueryKey: state.mediaQuery.key,
  }), shallowEqual)

  const setProperty = () => {
    document.documentElement.style.setProperty('--vh', `${window.innerHeight / 100}px`)
    theme.detect.vh = `${window.innerHeight / 100}px`
    window.vw = window.innerWidth
  }

  const events = () => {
    setProperty()
    if (theme.detect.hasTouch) {
      window.addEventListener('orientationchange', () => { setProperty() })
    }
    window.addEventListener('resize', () => { setProperty() })
  }

  useEffect(() => {
    events()
    if (ready) {
      const iubendaAccept = document.querySelector('.iubenda-cs-accept-btn')
      iubendaAccept?.addEventListener('click', () => {
        constants.EMITTER.emit(constants.EVENTS.DATALAYER.COOKIE_CONSENT)
      })
    }
  }, [ready])

  return (
    <div
      className={classNames({
        [classes.root]: true,
        'content-root': true,
        touch: theme.detect.hasTouch,
        no_touch: !theme.detect.hasTouch,
      })}
    >
      <ConditionalWrapper
        condition={!devMode}
        wrapper={(child) => <GoogleReCaptchaProvider reCaptchaKey={constants.config.RECAPTCHA_SITE_KEY}>{child}</GoogleReCaptchaProvider>}
      >
        <LoaderEngine />
        <Modal />
        <NewsletterPopup timeout={4000} />
        {mediaQueryKey > 1 && <Overlay />}
        <Spinner />
        <Nav
          mainNav={mainNav}
          extraNav={extraNav}
          languageNav={languageNav}
        />
        <CollectionNav collectionNav={collectionNav} />
        <Header
          menuLabel={strings.menu}
          closeLabel={strings.close}
        />
        <div className="wrapper">
          {children}
        </div>
        <SVGSprite />
        <ShopToastNotification />
      </ConditionalWrapper>
    </div>
  )
}

export default Layout
